import { HistoryMessages, MessageModelType } from '@/types/message';

/**
 * Kinds that can legitimately sit in `ChatContext.activeMessage` after a `History`
 * payload. Answer records ride along in `HistoryMessages` as transcript records, so
 * they must not become active interactive messages. ModulesProgress is activatable so
 * reconnect can remount the navigation interstitial while awaiting ConfirmNextModule.
 */
export function isActivatableHistoryMessage(message: HistoryMessages): boolean {
  return (
    message.kind === MessageModelType.Question ||
    message.kind === MessageModelType.MatrixQuestion ||
    message.kind === MessageModelType.Media ||
    message.kind === MessageModelType.Statement ||
    message.kind === MessageModelType.ModulesProgress
  );
}
